import React from 'react';

const ECG_POINTS =
  '0 18, 34 18, 44 18, 52 10, 59 30, 67 4, 75 28, 84 18, 126 18, 134 18, 142 10, 149 30, 157 4, 165 28, 174 18, 220 18';

const LoaderEcg: React.FC = () => (
  <svg className="grid-loading-ecg-svg" viewBox="0 0 220 36" role="presentation">
    <polyline className="grid-loading-ecg-base" points="0 18, 220 18" />
    <polyline className="grid-loading-ecg-wave" points={ECG_POINTS} />
    <polyline className="grid-loading-ecg-wave grid-loading-ecg-wave-alt" points={ECG_POINTS} />
  </svg>
);

export default LoaderEcg;
